var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgencyBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 120,
    viewBox: "0 0 181 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 120,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 45C62 43.8954 62.8954 43 64 43H81C82.1046 43 83 43.8954 83 45V52C83 53.1046 83.8954 54 85 54H109C110.105 54 111 53.1046 111 52V45C111 43.8954 111.895 43 113 43H117C118.105 43 119 43.8954 119 45V64C119 65.1046 118.105 66 117 66H64C62.8954 66 62 65.1046 62 64V45ZM119 72C119 70.8954 118.105 70 117 70H64C62.8954 70 62 70.8954 62 72V75C62 76.1046 62.8954 77 64 77H117C118.105 77 119 76.1046 119 75V72Z",
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyBlank);
export default __webpack_public_path__ + "static/media/agency_blank.89314a99cc9ca31936dd9e7bc2a2e586.svg";
export { ForwardRef as ReactComponent };